import React from 'react';
import { Grid, TextField } from '@mui/material';
import { UtilityService } from '../../../types/utility.types';

interface TelecomsFormProps {
  formData: UtilityService;
  handleFormChange: (field: string, value: any) => void;
  handleNestedChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isViewMode: boolean;
}

/**
 * Component for Telecoms contracts
 */
const TelecomsForm: React.FC<TelecomsFormProps> = ({
  formData,
  handleFormChange,
  handleNestedChange,
  isViewMode,
}) => {
  return (
    <Grid container spacing={3}>
      {/* Account Number */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Account Number"
          name="meterDetails.meterType"
          value={formData.meterDetails?.meterType || ''}
          onChange={handleNestedChange}
          disabled={Boolean(isViewMode)}
        />
      </Grid>
      
      {/* Service Type */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Service Type"
          name="meterDetails.location"
          value={formData.meterDetails?.location || ''}
          onChange={handleNestedChange}
          disabled={Boolean(isViewMode)}
          helperText="e.g., Broadband, Mobile, Landline"
        />
      </Grid>
      
      {/* Monthly Fee */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Monthly Fee"
          name="currentRate"
          value={formData.currentRate || ''}
          onChange={(e) => handleFormChange('currentRate', e.target.value)}
          disabled={Boolean(isViewMode)}
          helperText="£ per month"
        />
      </Grid>
      
      {/* Contract Value */}
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="Contract Value"
          name="contractValue"
          value={formData.contractValue || ''}
          onChange={(e) => {
            // Only allow numbers and decimal point
            const value = e.target.value;
            if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
              handleFormChange('contractValue', value);
            }
          }}
          disabled={Boolean(isViewMode)}
          InputProps={{
            startAdornment: <span style={{ marginRight: '4px' }}>£</span>,
          }}
          helperText="Enter contract value in pounds"
        />
      </Grid>
    </Grid>
  );
};

export default TelecomsForm;
